import { fetchJson } from './apiClient';

export type ManagerTask = 'finance' | 'subscriptions' | 'mini_websites' | 'crm' | 'marketing' | 'payments_settings' | 'support';

export const MANAGER_TASK_LABELS: Record<ManagerTask, string> = {
  finance: 'Finance & Payouts',
  subscriptions: 'Subscriptions',
  mini_websites: 'Mini Website Support',
  crm: 'CRM Management',
  marketing: 'Marketing & Communications',
  payments_settings: 'Payments & Settings',
  support: 'General Support',
};

export type ManagerRecord = {
  id: string;
  name: string;
  email: string;
  phone?: string;
  role?: string;
  isActive?: boolean;
  assignedTasks?: ManagerTask[];
};

export async function listManagers(): Promise<ManagerRecord[]> {
  return fetchJson(`/api/admin/managers`);
}

export async function createManager(payload: { name: string; email: string; phone?: string; role?: string; password?: string; assignedTasks?: ManagerTask[] }) {
  return fetchJson(`/api/admin/managers`, { method: 'POST', body: JSON.stringify(payload) });
}

export async function updateManager(id: string, payload: any) {
  return fetchJson(`/api/admin/managers/${encodeURIComponent(id)}`, { method: 'PATCH', body: JSON.stringify(payload) });
}

export async function toggleManagerActive(id: string, isActive: boolean) {
  return updateManager(id, { isActive });
}

export async function deleteManager(id: string) {
  await fetchJson(`/api/admin/managers/${encodeURIComponent(id)}`, { method: 'DELETE' });
  return true;
}

export default { listManagers, createManager, updateManager, deleteManager };
